import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { toggleSidebarCollapse, toggleMobileState, toggleSidebarShow, clearAppError } from '../../actions';
import Auth from './Login/Login'
import AuthTimer from './Login/AuthTimer'
import Portal from 'components/Portal/Portal'
import './Shell.scss';
import resizeDetectorMaker from 'element-resize-detector';
import FocusTrap from 'focus-trap-react'
import FloatingMenu from "components/FloatingMenu/FloatingMenu"
import HamburgerIcon from '@tecuity/sos-icons/react/hamburger'
import {history} from '../../store'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import CartButton from 'components/Cart/Cart'
import { Helmet } from "react-helmet";
import { SUBROUTES_OBJ } from '../../App'
import SkipLink from 'components/SkipLink/SkipLink'
// import { DISABLE_AUTH_CHECK } from '../../App'
let resizeDetector = resizeDetectorMaker();
let STATE_ABBR = process.env.STATE_ABBR;
STATE_ABBR = STATE_ABBR.toUpperCase()
let LOGO_FILENAME = process.env.LOGO_FILENAME;
let SEAL_FILENAME = process.env.SEAL_FILENAME;
const Logo = require("../../common/img/seals/" +
  STATE_ABBR +
  (LOGO_FILENAME
    ? `/${LOGO_FILENAME}`
    : SEAL_FILENAME ? `/${SEAL_FILENAME}` : "/seal.svg"))
const LOGO_ALT = process.env.LOGO_ALT || `${process.env.STATE_NAME} ${process.env.STATE_ORG_TITLE}`
const FOOTER_LINKS = process.env.FOOTER_LINKS
const LOGO_LINK_URL = process.env.LOGO_LINK_URL || '/'
const SHOPPING_CART = process.env.SHOPPING_CART;
const LOGO_FULL_WIDTH = process.env.LOGO_FULL_WIDTH

export let Content = ({
  children,
  subLinks,
  sidebarCollapsed,
  isMobile,
  currentPath,
  currentRoute,
  hideAppShell,
  hideSidebar
}) => {
  return (
    <div
      className={`content ${sidebarCollapsed ? 'sidebar-collapsed ' : ' '} ${
        isMobile ? 'mobile' : ''
      } ${hideAppShell ? 'no-shell' : ''}`}
    >
      {
        hideAppShell ?
        <Helmet>
          <style type="text/css">
            {`header.main-header, nav.sidebar, footer, .skip-link{
              display: none !important;
            }`}
          </style>
        </Helmet>
        : null
      }
      {
        hideSidebar ?
        <Helmet>
          <style type="text/css">
            {`nav.sidebar{
              display: none !important;
            }`}
          </style>
        </Helmet>
        : null
      }
      <Header subLinks={subLinks} currentPath={currentPath} currentRoute={currentRoute} />
      <div
        className={
          'body-wrapper ' +
          (sidebarCollapsed ? 'sidebar-collapsed ' : ' ') +
          (isMobile ? 'mobile' : '')
        }
      >
        {children}
      </div>
    </div>
  )
}
Content = connect(state => ({
  sidebarCollapsed: state.app.sidebarCollapsed,
  isMobile: state.app.isMobile,
  sidebarShown: state.app.sidebarShown
}))(Content)


class Header extends Component{
  state = {
    sublinkMenuOpen: false,
    sublinkMenuAnchor: null,
    sublinkMenuVisible: false
  }
  componentWillMount = () => {
    window.addEventListener('resize', this.toggleMenuType)
  }
  componentDidMount = () => {
    this.toggleMenuType()
  }
  componentDidUpdate = prevProps => {
    if(this.props.currentPath !== prevProps.currentPath){
      this.toggleMenuType()
    }
  }
  componentWillUnmount = () => {
    window.removeEventListener('resize', this.toggleMenuType)
  }
  toggleMenuType = e => {
    const headerHeight = this.header.offsetHeight;
    const navHeight = this.navLinks.offsetHeight
    if(navHeight > headerHeight){
      if(this.state.sublinkMenuVisible === false){
        this.setState({
          sublinkMenuVisible: true
        })
      }
    }else{
      if(this.state.sublinkMenuVisible === true){
        this.setState({
          sublinkMenuVisible: false
        })
      }
    }
  }
  toggleSidebarShow = () => {
    this.props.toggleSidebarShow(true)
    document.body.style.overflow = 'hidden';
  }
  openSublinkMenu = () => {
    this.setState({sublinkMenuOpen: true, sublinkMenuAnchor: this.sublinkMenuButton})
  }
  closeSublinkMenu = () => {
    this.setState({sublinkMenuOpen: false})
  }
  navigate = link => {
    history.push(link.value)
  }
  render(){
    const { isMobile, sidebarShown, subLinks=[], currentPath } = this.props;
    const linkSplit = currentPath ? currentPath.split('/') : []
    const currentSublink = SUBROUTES_OBJ[linkSplit[linkSplit.length - 1]] || {};
    return(
      <header className={`main-header ${isMobile ? "mobile" : ""}`} ref={r=>{this.header=r}}>
        {
          !isMobile &&
          <a className="child-focus" tabIndex="2" href={LOGO_LINK_URL} aria-label={`${process.env.STATE_NAME} ${process.env.STATE_ORG_TITLE}`}>
            <div className={"branding " + (sidebarShown ? "show" : "")}>
              {
                LOGO_FILENAME ?
                <div className={`logo-wrapper ${LOGO_FULL_WIDTH ? 'full-width' : ''}`}>
                  <img src={Logo} alt={LOGO_ALT}/>
                </div>
                :
                <React.Fragment>
                  <img src={Logo} alt={LOGO_ALT}/>
                  <span className="title-container">
                    <div className="statetitle">{process.env.STATE_NAME}</div>
                    <div className="subtext">{process.env.STATE_ORG_TITLE}</div>
                  </span>
                </React.Fragment>
              }
            </div>
          </a>
        }
        {
          isMobile ?
          <button tabIndex="2" className="sidebar-toggle" onClick={this.toggleSidebarShow} aria-label="Show/hide menu" aria-expanded={this.props.sidebarShown}>
            <div className="center">
              <HamburgerIcon/>
            </div>
          </button>
          : null
        }
        <nav className='sublinks-wrapper'>
          <div className='sublinks' ref={r=>{this.navLinks=r}}>
            <div className='wrap-enforcer'/>
            <div className={`force-wrap ${this.state.sublinkMenuVisible ? 'hidden' : ''}`}>
              {subLinks.map((link, i) => (
                <NavLink to={link.path} className="sublink" exact activeClassName="active" key={i}>
                  {link.label}
                </NavLink>
              ))}
            </div>
            <button
              onClick={this.openSublinkMenu}
              className={`more-button ${this.state.sublinkMenuVisible ? '' : 'hidden'}`}
              ref={r => {
                this.sublinkMenuButton = r
              }}
              aria-label="Pick a category"
            >
              {currentSublink.label} <div className="triangle" />
            </button>
            <FloatingMenu
              className="home-icon-menu"
              isOpen={this.state.sublinkMenuOpen}
              alignTo={this.state.sublinkMenuAnchor}
              align="right"
              offsetTop={32}
              onRequestClose={this.closeSublinkMenu}
              options={subLinks.map(link => ({value: link.path, label: link.label, onClick: this.navigate}))}
            />
          </div>
        </nav>
        {
          SHOPPING_CART &&
          <CartButton />
        }
        <Auth />
        <AuthTimer />
      </header>
    )
  }
}
Header = connect(
  (state) => ({
    isMobile: state.app.isMobile,
    sidebarShown: state.app.sidebarShown,
    param: state.router.location.pathname.split('/')[state.router.location.pathname.split('/').length - 1]
  }),
  {toggleSidebarShow}
)(Header)

export class SidebarNav extends Component{
  componentWillMount = () => {
    window.addEventListener('resize', this.toggleSidebarCollapse)
  }
  componentDidMount = () => {
    this.toggleSidebarCollapse();
  }
  componentWillUnmount = () => {
    window.removeEventListener('resize', this.toggleSidebarCollapse)
  }
  toggleSidebarCollapse = () => {
    if(this.props.shouldControlSidebarSize){
      if(document.body.clientWidth < 600){
        this.props.toggleMobileState(true)
        this.props.toggleSidebarCollapse(false)
      }
      else if(document.body.clientWidth < 900){
        this.props.toggleSidebarCollapse(true)
        this.props.toggleMobileState(false)
      }else{
        this.props.toggleSidebarCollapse(false)
        this.props.toggleMobileState(false)
      }
    }
  }
  toggleSidebarShow = () => {
    this.props.toggleSidebarShow(false)
    document.body.style.overflow = '';
  }
  blurOut = () => {
  setTimeout(()=> {
    if (!this.sidebarWrapper.contains(document.activeElement)){
      this.toggleSidebarShow();
    }
  })
}
  portalTarget = document.getElementById("sidebar-navigation")
  render(){
    const {links, collapsed, isMobile, sidebarShown, loggedIn, userGroup, siteOffline} = this.props;
    return(
      <Portal isOpened node={this.portalTarget}>
      <SkipLink/>
        <div ref={(ref)=> {this.sidebarWrapper = ref}}>
          <nav onBlur={this.blurOut} className={"sidebar " + (collapsed ? "collapsed " : " ") + (isMobile ? "mobile " : " ") + (sidebarShown ? "show" : "")}>
            {
              isMobile &&
              <div className={"branding " + (sidebarShown ? "show" : "")}>
                {
                  LOGO_FILENAME ?
                  <div className="logo-wrapper">
                    <img src={Logo} alt={LOGO_ALT}/>
                  </div>
                  :
                  <React.Fragment>
                    <img src={Logo} alt={LOGO_ALT}/>
                    <span className="title-container">
                      <div className="statetitle">{process.env.STATE_NAME}</div>
                      <div className="subtext">{process.env.STATE_ORG_TITLE}</div>
                    </span>
                  </React.Fragment>
                }
              </div>
            }
            {links.map((link, i)=>{
              if(link.includeInSidebar){
                var isPdf = false;
                if (link.link.endsWith('.pdf')) {
                  isPdf = true;
                }
                let renderedLink =  <SidebarLink {...link} onClick={isMobile ? this.toggleSidebarShow : undefined} hiddenText={isPdf ? "PDF" : null} key={i}/>
                if(link.authOnly || link.alwaysShowInSidebar){
                  if(loggedIn || link.alwaysShowInSidebar){
                    if(link.allowedUserGroups){
                      if(link.allowedUserGroups.includes(userGroup) || link.alwaysShowInSidebar){
                        return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
                      }else{
                        return null
                      }
                    }else{
                      return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
                    }
                  }else{
                    return null
                  }
                }else{
                  return siteOffline ? link.linkAvailableOffline ? renderedLink : null : renderedLink;
                }
              }else{
                return null
              }
            })}
          </nav>
          {sidebarShown ?
            <div className="sidebar-shade animated fadeIn extra-fast-animation" onClick={this.toggleSidebarShow}></div>
          : null}
        </div>
      </Portal>
    )
  }
}
SidebarNav = connect(
  (state) => ({
    collapsed: state.app.sidebarCollapsed,
    location: state.router.location,
    isMobile: state.app.isMobile,
    sidebarShown: state.app.sidebarShown,
    shouldControlSidebarSize: !state.app.overrideSidebarResizing,
    loggedIn: state.auth.loggedIn,
    userGroup: state.auth.USER_GROUP,
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true
  }),
  {toggleSidebarCollapse, toggleMobileState, toggleSidebarShow}
)(SidebarNav)

const SidebarLink = ({
  label,
  link,
  icon,
  exact,
  linkExact,
  numAlerts = 0,
  isActive,
  onClick,
  onBlur,
  hiddenText,
  external,
}) => (
  external ?
  <a
    href={link}
    target='_blank'
    rel="noopener noreferrer"
  >
    {numAlerts > 0 ? <Alert number={numAlerts} /> : null}
    {icon && icon} <span className="label">{label}</span>
    <span className="visually-hidden">{hiddenText}</span>
  </a>
  :
  <NavLink
    to={link}
    exact={linkExact === false || linkExact === true ? linkExact : exact}
    isActive={isActive}
    activeClassName="active"
    onClick={onClick}
    onBlur={onBlur}
  >
    {numAlerts > 0 ? <Alert number={numAlerts} /> : null}
    {icon && icon} <span className="label">{label}</span>
  </NavLink>
)

const Alert = ({number}) => (
  <div className="badge sidebar-alert">{number}</div>
)

export class Drawer extends Component {
  state = {
    render: this.props.show || false,
    closing: false
  }
  componentWillReceiveProps = nextProps => {
    if (!this.props.show && nextProps.show === true) {
      this.setState({
        render: true,
        closing: false
      }, () => {
        this.innerWrapper.focus()
      })
    }
    if (this.props.show === true && !nextProps.show) {
      this.setState({
        closing: true
      })
    }
  }
  onSidebarDismiss = () => {
    if (this.props.onSidebarDismiss) {
      this.props.onSidebarDismiss()
    }
  }
  onAnimationEnd = () => {
    if (this.props.show === false) {
      this.setState({
        render: false,
        closing: false
      })
    }
  }
  render() {
    const {
      show = false,
      children,
      title = "",
      subtitle,
      isMobile,
      scrollable,
      showCloseButton,
      alwaysShowClosebutton,
      ariaCloseLabel
    } = this.props
    let titleArray = title ? title.split("||") : []
    return this.state.render ? (
      <FocusTrap
        focusTrapOptions={{ clickOutsideDeactivates: true }}
        active={show && !this.state.closing}
        className={`drawer ${show ? "show" : ""} ${isMobile ? "mobile" : ""} ${
          this.state.closing ? "closing" : ""
        }`}
        onAnimationEnd={this.onAnimationEnd}
        aria-hidden={!show}
        aria-live="polite"
        role="complementary"
      >
        <div className="drawer-inner-wrapper" tabIndex="-1" ref={r => this.innerWrapper = r}>
          {title ? (
            <div className="title-box">
              <h4>{titleArray.length !== null ? titleArray[0] : "undefined"}</h4>
              <p>{subtitle}</p>
              {isMobile ? (
                <button
                  className="sidebar-dismiss"
                  onClick={this.onSidebarDismiss}
                >
                  <div className="center">
                    <CaretLeftIcon/>
                  </div>
                </button>
              ) : null}
              {(!isMobile || alwaysShowClosebutton) && showCloseButton ? (
                <button className="close-button" onClick={this.onSidebarDismiss} aria-label={ariaCloseLabel || "Close"}>
                  <div className="center">
                    <CrossIcon/>
                  </div>
                </button>
              ) : null}
            </div>
          ) : null}
          <div className="scrollable-drawer-wrapper">
            <div className={"inner-drawer " + (scrollable ? "scrollable" : "")}>
              {children}
            </div>
          </div>
        </div>
      </FocusTrap>
    ) : null
  }
}
Drawer = connect(state => ({
  isMobile: state.app.isMobile
}))(Drawer)

export class Body extends Component {
  componentDidMount = () => {
    if (this.props.onResize)
      resizeDetector.listenTo(this.body, this.onResize)
  }
  componentWillUnmount = () => {
    if (this.props.onResize)
      resizeDetector.removeListener(this.body, this.onResize)
  }
  onResize = body => {
    this.props.onResize({
      width: body.offsetWidth,
      height: body.offsetHeight
    })
  }
  render() {
    const {
      className = "",
      showDrawer = false,
      children,
      isMobile,
      appError = {},
      style = {},
      backgroundThemeColor,
      innerRef,
      hiddenTitle
    } = this.props
    return (
      <main
        ref={ref => {
          this.body = ref;
          if(innerRef){
            innerRef(ref)
          }
        }}
        className={`body container-fluid ${className ? className : ""} ${
          showDrawer ? "drawer-shown" : ""
        } ${isMobile ? "mobile" : ""} ${backgroundThemeColor ? backgroundThemeColor : ''}`}
        style={style}
      >
        {
          hiddenTitle ?
          <h1 className="visually-hidden">{hiddenTitle}</h1>
          : null
        }
        {appError.show ? <AppError {...appError} /> : null}
        {children}
      </main>
    )
  }
}
Body = connect(state => ({
  isMobile: state.app.isMobile,
  appError: state.app.appError
}))(Body)


class AppError extends Component{
  render(){
    const {error="Oops, something went wrong. Refresh your page and try again.", type="danger"} = this.props;
    return(
      <div className={`app-error ${type} animated fadeIn fast-animation`}>
        {error}
        <button onClick={this.props.clearAppError}><span className="icon icon-cross"></span></button>
      </div>
    )
  }
}
AppError = connect(
  null,
  {clearAppError}
)(AppError)

export class Footer extends Component{
  render(){
    const { children, copyright, isMobile, sidebarCollapsed } = this.props;
    const date = new Date();
    return(
      <footer className={(isMobile ? "mobile " : " ") + (sidebarCollapsed ? "collapsed" : "")}>
        {
          copyright ?
          <span className="copyright">© {date.getFullYear()} {copyright}</span>
          : null
        }
        {children ? children : null}
        {
          FOOTER_LINKS !== false && Array.isArray(FOOTER_LINKS) ?
          <ul className="links">
            {FOOTER_LINKS.map((link, i) => (
              <li key={i}>
                <a href={link.link} key={i}>{link.label}</a>
                {i !== FOOTER_LINKS.length - 1 ? <span className="divider" key={i + link.label}>|</span> : null}
              </li>
            ))}
          </ul>
          : null
        }
      </footer>
    )
  }
}
Footer = connect(
  (state) => ({
    isMobile: state.app.isMobile,
    sidebarCollapsed: state.app.sidebarCollapsed
  })
)(Footer)

export const FlexWrapper = ({children, justifyContent, direction}) => (
  <div className="flex-wrapper" style={{
    justifyContent: (justifyContent ? justifyContent : ""),
    flexDirection: (direction ? direction : "")
  }}>{children}</div>
)

export const Triangle = ({direction='down', className=''}) => <div className={`triangle ${direction} ${className}`} />



// WEBPACK FOOTER //
// ./src/components/Shell/Shell.js